import { Inline, Text, textVariants } from '@etg/wings';
import { ScreenReaderPrice } from '@eti/components';
import { css, mediaQueries } from '@eti/styles';
import { price as priceUtils } from '@eti/utils';
import { useProperty, useTranslation } from '@eti/providers';
import { isCarrierCodesPresentInSomeSegments } from '../../../common/utils/carriersUtils';
import { getPriceDivided } from '../../../common/utils/price';
import { screenReaderOnly } from '../../../common/utils/styles';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const baggageChoiceDescriptionStyle = css`
  align-items: start;
  flex-direction: column;
`;
const productDescriptionStyle = css`
  flex-grow: 1;

  @media ${mediaQueries.small.only} {
    line-height: 1;
  }
`;
const getPriceBreakdownForCarrier = _ref => {
  let {
    ancillaryCarrierPriceBreakdowns,
    priceBreakdownText,
    markupLabel,
    markup
  } = _ref;
  const carrierProviderTextHtml = ancillaryCarrierPriceBreakdowns.map(_ref2 => {
    let {
      carrier,
      providerPrice
    } = _ref2;
    if (!(carrier !== null && carrier !== void 0 && carrier.name)) {
      return null;
    }
    return `<bdi>${carrier.name} ${priceUtils.formatPrice(providerPrice.value)}</bdi>`;
  }).filter(Boolean).join(' + ');
  const markupHtml = `<bdi>${markupLabel} ${priceUtils.formatPrice(markup)}</bdi>`;
  return carrierProviderTextHtml ? priceBreakdownText(carrierProviderTextHtml, markupHtml) : '';
};
const BaggageSelectionPriceInformation = _ref3 => {
  var _order$bounds$length, _order$bounds, _order$configuration;
  let {
    baggageOption,
    order,
    productName
  } = _ref3;
  const {
    t
  } = useTranslation();
  const {
    p
  } = useProperty();
  const {
    id,
    label,
    ancillaryCarrierPriceBreakdowns = [],
    markup = 0,
    priceRaw = 0
  } = baggageOption;
  const labels = {
    markupLabel: t('Product.Markup.Label'),
    perBoundLabel: t('Products.Price.Label.PerBounds', ''),
    screenReaderText: t('ScreenReader.Product.Pricebreakdown.Label'),
    priceBreakdownText: (carrierProviderText, markupText) => t('Product.Carrier.PriceBreakdown.Text', carrierProviderText, markupText)
  };
  const {
    markupLabel,
    perBoundLabel,
    priceBreakdownText,
    screenReaderText
  } = labels;
  const numberOfBounds = (_order$bounds$length = (_order$bounds = order.bounds) === null || _order$bounds === void 0 ? void 0 : _order$bounds.length) !== null && _order$bounds$length !== void 0 ? _order$bounds$length : 0;
  const showPricePerBound = Boolean(((_order$configuration = order.configuration) === null || _order$configuration === void 0 || (_order$configuration = _order$configuration.travelerDetails) === null || _order$configuration === void 0 ? void 0 : _order$configuration.showPricePerBound) && numberOfBounds > 1 && perBoundLabel);
  const ryanairCarrierCodes = p('IbeClient.RyanairMarketingCarriers') || [];
  const isRyanairInTrip = isCarrierCodesPresentInSomeSegments(ryanairCarrierCodes, order.bounds);
  if (isRyanairInTrip) {
    const carrierPricebreakdownText = getPriceBreakdownForCarrier({
      ancillaryCarrierPriceBreakdowns,
      priceBreakdownText,
      markup,
      markupLabel
    });
    const screenReaderCarrierPricebreakdownText = `${screenReaderText}: ${carrierPricebreakdownText}`;
    const showPriceBreakdown = Boolean(ancillaryCarrierPriceBreakdowns.length && carrierPricebreakdownText);
    return /*#__PURE__*/_jsxs(Inline, {
      className: baggageChoiceDescriptionStyle,
      spacing: 8,
      children: [/*#__PURE__*/_jsx(Text, {
        as: "bdi",
        children: label
      }), Boolean(priceRaw) && /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsxs(Text, {
          "aria-hidden": "true",
          as: "p",
          "data-testid": `toggleChoice-${productName}-${id}-price`,
          children: [/*#__PURE__*/_jsx(Text, {
            variant: textVariants._14_BOLD,
            children: priceUtils.formatPrice(priceRaw)
          }), "\xA0", showPriceBreakdown && /*#__PURE__*/_jsx(Text, {
            as: "span",
            asHtml: true,
            color: "secondary",
            "data-testid": `toggleChoice-${productName}-${id}-pricebreakdown`,
            children: carrierPricebreakdownText
          })]
        }), /*#__PURE__*/_jsx(ScreenReaderPrice, {
          price: priceUtils.formatPrice(priceRaw)
        }), /*#__PURE__*/_jsx(Text, {
          asHtml: true,
          className: screenReaderOnly,
          children: screenReaderCarrierPricebreakdownText
        })]
      })]
    });
  }
  const formattedPrice = priceUtils.formatPrice(showPricePerBound ? getPriceDivided(priceRaw, numberOfBounds) : priceRaw);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(Inline, {
      as: "bdi",
      className: productDescriptionStyle,
      children: label
    }), Boolean(priceRaw) && /*#__PURE__*/_jsxs(Inline, {
      spacing: 4,
      children: [/*#__PURE__*/_jsx(Text, {
        "aria-hidden": "true",
        "data-testid": `toggleChoice-${productName}-${id}-price`,
        variant: textVariants._14_BOLD,
        children: formattedPrice
      }), /*#__PURE__*/_jsx(ScreenReaderPrice, {
        price: formattedPrice
      }), showPricePerBound && /*#__PURE__*/_jsx(Text, {
        "data-testid": "per-bound-label",
        children: perBoundLabel
      })]
    })]
  });
};
export default BaggageSelectionPriceInformation;
//# sourceMappingURL=BaggageSelectionPriceInformation.js.map